<template>
  <el-main class='main' style="height: calc(100vh - 56px - 20px);padding: 0px;background-color: #FFFFFF;">
    <el-row>
      <el-col :span="2" class="left">
        <div class="title">设备列表</div>
        <div @click="queryAiDataSet(deviceInstantiation.id)" :class="'deviceInstantiation ' + (deviceInstantiationId==deviceInstantiation.id?'deviceInstantiationCur':'')" v-for="deviceInstantiation in deviceInstantiations" :key="deviceInstantiation.id">{{ deviceInstantiation.name }}({{ deviceInstantiation.id }})</div>
      </el-col>
      <el-col :span="22" class="right">
        <el-row class="top">
          采样时间：
          <el-date-picker type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" v-model="timeRange"></el-date-picker>
          <el-button type="success" @click="queryAiDataSet(deviceInstantiationId)" icon="el-icon-search" style="background-color: #209323;">查询</el-button>
        </el-row>
        <el-row class="middle">
          <el-col :span="13" class="l">
            <img :src="apiUrl+'/aiDataSetAnalysis/getOnePic?md5='+aiDataSetAnalysis.md5+'&time='+(new Date().getTime())" v-if="aiDataSetAnalysis && aiDataSetAnalysis.md5"/>
            <img :src="apiUrl+'/aiDataSet/getOnePic?md5='+choseAiDataSet.md5" v-if="!aiDataSetAnalysis || !aiDataSetAnalysis.md5"/>
          </el-col>
          <el-col :span="11" class="r">
            <div class="images">
              <div :class="'image '+ (aiDataSet.id==choseAiDataSet.id?'imageCur':'')" v-for="aiDataSet in aiDataSets" :key="aiDataSet.id" @click="clickAiDataSet(aiDataSet)">
                <img :src="apiUrl+'/aiDataSet/getOnePic?md5='+aiDataSet.md5"/>
                <div class="text">{{ formatDate(aiDataSet.addTime) }}</div>
              </div>
            </div>
            <div class="pages">
              <el-pagination background layout="prev, pager, next" :total="aiDataSetsTotal" @current-change="queryAiDataSetForPage"></el-pagination>
            </div>
          </el-col>
        </el-row>
        <el-row class="bottom">
          <el-row class="t1">分析报表</el-row>
          <el-row>
            <el-col :span="12" class="l">
              <div class="t2">虫情信息:</div>
              <el-row class="content">
                <el-col :span="12" v-for="item in aiDataSetAnalysis.analysisContentArray" :key="item.name" v-if="aiDataSetAnalysis.analysisContentArray && aiDataSetAnalysis.analysisContentArray.length>0">
                  <el-col :span="18" class="tb">{{ item.name }}</el-col>
                  <el-col :span="6" class="tc">{{ item.num }}</el-col>
                </el-col>
                <el-col :span="24" v-if="!aiDataSetAnalysis.analysisContentArray || aiDataSetAnalysis.analysisContentArray.length==0">未识别出虫害</el-col>
              </el-row>
            </el-col>
            <el-col :span="12" class="r">
              <el-row>
                <el-col :span="3" class="tb">分析员：</el-col>
                <el-col :span="4" class="tc"> {{ aiDataSetAnalysis.remark }}</el-col>
                <el-col :span="3" class="tb">分析时间：</el-col>
                <el-col :span="7" class="tc"> {{ formatDate(aiDataSetAnalysis.addTime) }}</el-col>
                <el-col :span="7">
                  <el-button size="small" type="warning" @click="clickAnalysis()">人工识别</el-button>
                  <!-- <el-button size="small" type="danger">删除报告</el-button> -->
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="4" class="tb">
                  分析备注：
                </el-col>
                <el-col :span="20" class="tc">
                  {{ aiDataSetAnalysis.remark }}
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-row>
      </el-col>
    </el-row>
    <el-dialog title="图片标记" :visible.sync="dialogVisible" width="1140px" top="30px" :modal="true">
      <div :style="'width:1100px;height:'+imageHeight+'px;'">
        <img :src="apiUrl+'/aiDataSet/getOnePic?md5='+choseAiDataSet.md5" style="position: absolute;width:1100px;user-select: none;overflow-clip-margin: content-box;overflow: clip;display: block;-webkit-user-drag: none;cursor: crosshair;" @mousedown="imgDown($event)" @mouseup="imgUp($event)" @mousemove="imgMove($event)" @load="handleImageLoad"/>
        <div :style="'position: absolute;left: '+(item.pointStart[0]+20)+'px;top: ' +(item.pointStart[1]+60)+'px;'" v-for="item in rects" :key="item.id">
          <div style="font-size: 12px;line-height: 20px;background-color: #209323;color: #FFFFFF;width: 100px;"><i class="el-icon-close" @click="onLabelDel(item.id)" style="cursor: pointer;"></i>&nbsp;&nbsp;{{ item.name }}</div>
          <div :style="'width: '+(item.pointEnd[0] - item.pointStart[0])+'px;height: '+((item.pointEnd[1] - item.pointStart[1]))+'px;background-color: rgba(255, 0, 0, 0.5); '"></div>
        </div>
        <div :style="'position: absolute;left: '+(rectType.pointStart[0]+20)+'px;top: ' +(rectType.pointStart[1]+60)+'px;'" v-if="rectType.show">
          <div :style="'width: '+rectType.width+'px;height: '+rectType.height+'px;background-color: rgba(255, 0, 0, 0.5); '"></div>
        </div>
      </div>
      <div class=""></div>
      <!-- <canvas ref="canvas" width="1100px" height="825px" @mousedown="canvasDown($event)" @mouseup="canvasUp($event)" @mousemove="canvasMove($event)"></canvas> -->
    </el-dialog>  
    
    <el-dialog title="图片标记" :visible.sync="dialogLabelVisible" width="600px" top="60px" :modal="true">
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="标记名称">
          <el-select v-model="form.labelName" placeholder="请选择活动区域" filterable>
            <el-option :label="item.name" :value="item.name" v-for="item in pests" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onLabelSubmit" style="background-color: #209323;">确认</el-button>
          <el-button @click="onLabelCanel">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </el-main>
</template>
<script>
import requestService from '../../../util/request'
import { formatDate } from '../../../util/date'

export default {
  data () {
    return {
      apiUrl: '',
      current: 1,
      deviceInstantiations: [],
      aiDataSets: [],
      options: [{}],
      deviceInstantiationId: 0,
      timeRange: [],
      aiDataSetsTotal: 1,
      choseAiDataSet: {},
      aiDataSetAnalysis: {},
      dialogVisible: false,
      pointStart: [0, 0],
      pointEnd: [0, 0],
      rects: [],
      imageWidth: 0,
      imageHeight: 0,
      rectType: {show: false, width:0, height:0, pointStart:[0, 0], pointEnd:[0, 0], stop: false, start: true},
      pests: [],
      dialogLabelVisible: false,
      form: {
        labelName: null,
        aiDataSetId: null
      }
    }
  },
  created () {
    this.queryDeviceInstantiationsForPest()
    this.apiUrl = this.$global.apiUrl
    this.queryDiseaseInsectPests()
  },
  methods: {
    clickAnalysis () {
      this.dialogVisible = true
      this.rectType = {show: false, width:0, height:0, pointStart:[0, 0], pointEnd:[0, 0], stop: false, start: false}
      // this.loadImageToCanvas(this.apiUrl+'/aiDataSet/getOnePic?md5='+this.choseAiDataSet.md5+'&timestamp='+new Date().getTime())
    },
    onLabelCanel () {
      this.form.labelName = null
      this.dialogLabelVisible = false
    },
    onLabelSubmit () {
      let that = this
      this.dialogLabelVisible = false
      this.form.aiDataSetId = this.choseAiDataSet.id
      this.form.labelContent = '['+JSON.stringify(this.pointStart)+','+JSON.stringify(this.pointEnd)+']'
      requestService.post('/aiDataSetLabel/add', that.form, {headers: {'Content-Type': 'application/json'}}).then((res) => {
        that.queryAiDataSetLabel()
      })
    },
    onLabelDel (id) {
      let that = this
      requestService.post('/aiDataSetLabel/del', {id: id}, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.queryAiDataSetLabel()
      })
    },
    handleImageLoad(event) {
      this.imageHeight = event.target.naturalHeight;
      this.imageWidth = event.target.naturalWidth;
    },
    imgDown (e) {
      this.pointStart[0] = e.offsetX
      this.pointStart[1] = e.offsetY
      this.rectType.start = true
      this.rectType.stop = false
      this.rectType.pointStart = this.pointStart
      console.log(this.pointStart)
    },
    imgMove (e) {
      if (this.rectType.stop) {
        return
      }
      if (!this.rectType.start) {
        return
      }
      this.pointEnd[0] = e.offsetX
      this.pointEnd[1] = e.offsetY
      let width = this.pointEnd[0] - this.pointStart[0]
      let height = this.pointEnd[1] - this.pointStart[1]
      this.rectType.show = true
      this.rectType.pointEnd = this.pointEnd
      this.rectType.width = width
      this.rectType.height = height
    },
    imgUp (e) {
      this.pointEnd[0] = e.offsetX
      this.pointEnd[1] = e.offsetY
      let width = this.pointEnd[0] - this.pointStart[0]
      let height = this.pointEnd[1] - this.pointStart[1]
      this.rectType.stop = true
      this.rectType.start = false
      this.rectType.pointEnd = this.pointEnd
      this.rectType.width = width
      this.rectType.height = height
      this.dialogLabelVisible = true
    },
    // canvasDown (e) {
    //   this.pointStart[0] = e.offsetX
    //   this.pointStart[1] = e.offsetY
    // },
    // canvasMove (e) {
    //   console.log(e)
    //   this.pointEnd[0] = e.offsetX
    //   this.pointEnd[1] = e.offsetY
    //   // 绘制矩形
    //   let canvas = this.$refs.canvas;
    //   let ctx = canvas.getContext('2d');
    //   ctx.beginPath();
    //   let width = this.pointEnd[0] - this.pointStart[0]
    //   let height = this.pointEnd[1] - this.pointStart[1]
    //   ctx.rect(this.pointStart[0], this.pointStart[1], width, height);
    //   ctx.lineWidth = 2;
    //   ctx.strokeStyle = '#209323';
    // },
    // canvasUp (e) {
    //   this.pointEnd[0] = e.offsetX
    //   this.pointEnd[1] = e.offsetY
    //   // 绘制矩形
    //   let canvas = this.$refs.canvas;
    //   let ctx = canvas.getContext('2d');
    //   ctx.stroke();
    // },
    // async loadImageToCanvas(imageUrl) {
    //   let imageTemp = await this.loadImage(imageUrl);
    //   let canvas = this.$refs.canvas;
    //   canvas.width = imageTemp.width;
    //   canvas.height = imageTemp.height;
    //   let ctx = canvas.getContext('2d');
    //   ctx.drawImage(imageTemp, 0, 0);
    // },
    // loadImage(url) {
    //   return new Promise((resolve, reject) => {
    //     let imageTemp2 = new Image();
    //     imageTemp2.onload = () => resolve(imageTemp2);
    //     imageTemp2.onerror = reject;
    //     imageTemp2.src = url;
    //   });
    // },    
    queryDeviceInstantiationsForPest () {
      let that = this
      requestService.get(`/deviceInstantiation/listPage?current=1&pageSize=65535&type=10`, {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.deviceInstantiations = res.data.body.records
        if (that.deviceInstantiations && that.deviceInstantiations.length > 0) {
          that.queryAiDataSet(that.deviceInstantiations[0].id)
        }
      })
    },
    queryAiDataSetLabel () {
      let that = this
      that.rects = []
      requestService.get(`/aiDataSetLabel/listPage?current=1&pageSize=65535&aiDataSetId=${this.choseAiDataSet.id}`, {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        for(let item of res.data.body.records){
          let points = JSON.parse(item.labelContent)
          let temp = {}
          temp.id = item.id
          temp.name = item.labelName
          temp.addTime = item.addTime
          temp.pointStart = points[0]
          temp.pointEnd = points[1]
          that.rects.push(temp)
        }
        console.log(that.rects)
      })
    },
    queryAiDataSet (deviceInstantiationId) {
      let that = this
      that.deviceInstantiationId = deviceInstantiationId
      that.current = 1
      let sTimeStr = ''
      let eTimeStr = ''
      if (this.timeRange && this.timeRange.length == 2) {
        sTimeStr = this.formatDate(this.timeRange[0])
        eTimeStr = this.formatDate(this.timeRange[1])
      }
      requestService.get(`/aiDataSet/listPage?current=${that.current}&pageSize=6&deviceInstantiationId=${deviceInstantiationId}&sTimeStr=${sTimeStr}&eTimeStr=${eTimeStr}`, {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.aiDataSets = res.data.body.records
        that.aiDataSetsTotal = res.data.body.total
        if (that.aiDataSets && that.aiDataSets.length > 0) {
          that.clickAiDataSet(that.aiDataSets[0])
        }
      })
    },
    queryAiDataSetAnalysis (aiDataSetId) {
      let that = this
      requestService.get(`/aiDataSetAnalysis/getOneByAiDataSetId?aiDataSetId=${aiDataSetId}`, {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        if (res.data.body) {
          that.aiDataSetAnalysis = res.data.body
          that.aiDataSetAnalysis.analysisContentArray = JSON.parse(that.aiDataSetAnalysis.analysisContent)
        }else{
          that.aiDataSetAnalysis = {}
          that.aiDataSetAnalysis.analysisContentArray = []
        }
      })
    },
    queryAiDataSetForPage (page) {
      let that = this
      that.current = page
      requestService.get(`/aiDataSet/listPage?current=${that.current}&pageSize=6&deviceInstantiationId=${this.deviceInstantiationId}`, {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.aiDataSets = res.data.body.records
        that.aiDataSetsTotal = res.data.body.total
        if (that.aiDataSets && that.aiDataSets.length > 0) {
          that.clickAiDataSet(that.aiDataSets[0])
        }
      })
    },
    queryDiseaseInsectPests () {
      let that = this
      requestService.get(`/diseaseInsectPest/list?type=1`, {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.pests = res.data.body
      })
    },
    clickAiDataSet (data) {
      this.choseAiDataSet = data
      this.queryAiDataSetAnalysis(this.choseAiDataSet.id)
      this.queryAiDataSetLabel()
    },
    formatDate (time, format) {
      var date = new Date(time)
      return formatDate(date, !format?'yyyy-MM-dd hh:mm:ss':format)
    }
  }
}
</script>

<style scoped>
.left{
  height: calc(100vh - 56px - 20px);
  border-right: 1px solid #B3B3B3;
  .title{
    line-height: 32px;
    font-size: 16px;
    font-weight: bold;
    background-color: #209323;
    color: #FFFFFF;
    padding-left: 10px;
    letter-spacing: 2px;
  }
  .deviceInstantiation{
    line-height: 32px;
    font-size: 12px;
    cursor: pointer;
    padding-left: 20px;
    letter-spacing: 1px;
  }
  .deviceInstantiationCur{
    font-weight: bold;
    color: darkgreen;
  }
}
.right{
  height: calc(100vh - 56px - 20px);
  padding-left: 20px;
  padding-right: 20px;
  .top{
    height: 40px;
  }
  .middle{
    height: 580px;
    margin-top: 10px;
    .l{
      img{
        width: 100%;
        height: 580px;
      }
    }
    .r{
      .images{
        height: 530px;
        overflow-y: auto;
        margin-left: 10px;
        .image{
          width: 30%;
          float: left;
          margin-bottom: 5px;
          border: #FFFFFF 6px solid;
          cursor: pointer;
          img{
            width: 100%;
          }
          .text{
            width: 100%;
            text-align: center;
            line-height: 30px;
            font-size: 12px;
          }
        }
        .imageCur{
          border: #209323 6px solid;
          .text{
            color: #FFFFFF;
            font-weight: bold;
            background-color: #209323;
          }
        }
      }
      .pages{
        padding-top: 10px;
        height: 40px;
      }
    }
  }
  .bottom{
    margin-top: 10px;
    padding: 6px;
    height: calc(100vh - 56px - 20px - 40px - 580px - 10px - 10px - 10px);
    border: 1px solid #209323;
    border-radius: 3px;
    .t1{
        line-height: 60px;
        font-size: 20px;
        font-weight: bold;
        letter-spacing: 1px;
        text-align: left;
      }
    .l{
      height: calc(100vh - 56px - 20px - 40px - 580px - 10px - 10px - 10px - 60px - 10px);
      border-right: 8px solid #FCFCFC;
      .t2{
        line-height: 30px;
        font-size: 16px;
        font-weight: bold;
        letter-spacing: 1px;
        text-align: left;
        .content{
          line-height: 40px;
        }
      }
    }
    .r{
      height: calc(100vh - 56px - 20px - 40px - 580px - 10px - 10px - 10px - 60px - 10px);
      padding-left: 10px;
    }
    .tb{
      line-height: 40px;
      font-weight: bold
    }
    .tc{
      line-height: 40px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/org-manage-components/aiDataSet/Index.vue